module.exports = __webpack_public_path__ + "img/flags.0b1ca148.png";